import { Quote } from "lucide-react";
import { AnimatedSection } from "./AnimatedSection";

const TESTIMONIALS = [
  {
    quote: "I've trusted Ranjith with our accounting, TDS, GST, and EPF for over a decade. Which is exactly why Grow High now manages accounting and compliance for my new startup.",
    name: "Pundari",
    role: "Co-Founder, Being Ultimate",
  },
  {
    quote: "Our statutory audit used to be stressful every year. With Grow High, it's calm and it's always on time.",
    name: "Divya S.",
    role: "Director, Manufacturing Firm",
  },
  {
    quote: "I call, they answer. I ask a basic question, they never make me feel small about it. That's rare.",
    name: "Suresh Kumar",
    role: "Founder, Logistics Startup",
  },
];

export const Testimonials = () => (
  <section id="testimonials" className="bg-[#F8FAFC] py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <AnimatedSection className="max-w-2xl mb-16">
        <p className="overline text-[#1E3A8A] mb-4">In Their Words</p>
        <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-[#0F172A]">
          Business owners who stopped worrying.
        </h2>
      </AnimatedSection>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <AnimatedSection
            key={i}
            delay={i * 0.12}
            data-testid={`testimonial-card-${i}`}
            className="bg-white border border-slate-200 rounded-2xl p-8 flex flex-col hover:-translate-y-1 transition-transform duration-300"
          >
            <Quote size={22} className="text-[#C5A059] mb-6" />
            <p className="text-slate-700 leading-relaxed mb-6 flex-1 text-base md:text-lg">&ldquo;{t.quote}&rdquo;</p>
            <div>
              <p className="font-medium text-[#0F172A] text-base">{t.name}</p>
              <p className="text-slate-500 text-sm mt-0.5">{t.role}</p>
            </div>
          </AnimatedSection>
        ))}
      </div>
    </div>
  </section>
);
